<template>
    <div class=" bg-round bg-fff">
        <div class="container">
            <Bread class="ma-t-30" />
            <header id="header">
                <div class="flex f-around">
                    <div class="header-li header-active" @click="$router.push('/about/team')">创始人Founder</div>
                    <div class="header-li" @click="$router.push('/merge/curator')">策展团队Curator</div>
                    <!-- <div class="header-li" @click="$router.push('/merge/jury')">评审团Jury</div> -->
                    <div class="header-li" @click="$router.push('/merge/volunteer')">志愿者团队volunteer</div>
                </div>
            </header>
        </div>

        <div class="container line-height-35 main-md vhtml" id="app">
            <div v-html="Content"></div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    .img-person {
        width: 220px;
    }

    @media (min-width: 768px) {
        #iframeFoot {
            margin-top: 120px;
        }

        .main-md {
            padding-left: 181px;
            padding-right: 210px;
        }
    }

    @media (max-width: 768px) {
        #iframeFoot {
            margin-top: 20px;
        }
    }
</style>
<script>
    import {getOther} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                footbottom:123,
                detail:"",
                Content:"",
            };
        },
        created() {
            console.log("开始开发")
            this.getDetail();
        },
        
        methods: {
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            //获取数据
            getDetail() {
                let data = {
                    code: "aboutus.founder",
                };
                getOther(data).then((res) => {
                    console.log(res);
                    this.detail = res.data.Data;
                    this.Content=res.data.Data.Content;
                });
            },
            toPage(url){
                this.$router.push("/merge/"+url);
            }
        },
    };
</script>
